import { Config } from '../types/config';

const isClient = () => typeof window !== 'undefined';
export const cookiesEnabled = isClient() ? navigator.cookieEnabled : false;

export const deployedEnvironments = {
    STAGING: 'staging',
    PRODUCTION: 'production',
};

export const isLocalEnv = (env: string) => !Object.values(deployedEnvironments).includes(env);
export const isStagingEnv = (env: string) => env === deployedEnvironments.STAGING;
export const isProductionEnv = (env: string) => env === deployedEnvironments.PRODUCTION;

export const getStaticResourceBaseUrl = (config: Config) => {
    const { staticHost } = config;
    const { bellaApiBaseUrl } = config;
    const isDevEnv = isLocalEnv(config.env);
    const baseUrl = isDevEnv ? `${bellaApiBaseUrl}${staticHost}` : staticHost;

    // Ensure trailing slash
    return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
};

export default isClient;
